var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13.5C16.5523 13.5 17 13.8124 17 14.6014V21.7442C17 22.5332 16.5523 23 16 23C15.4477 23 15 22.5332 15 21.7442V14.6014C15 13.8124 15.4477 13.5 16 13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C15 9.44772 15.4455 9 15.995 9H16.005C16.5545 9 17 9.44772 17 10C17 10.5523 16.5545 11 16.005 11H15.995C15.4455 11 15 10.5523 15 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterInfo);
export default __webpack_public_path__ + "static/media/toaster-info.f002f8c5d538a7e9798dcc83ff832e86.svg";
export { ForwardRef as ReactComponent };